import AboutUs from "./pages/AboutUs";
import InfluencerDashboard from './pages/InfluencerDashboard';
import InfluencerInvitation from './pages/InfluencerInvitation';
import CustomerReferrals from './pages/CustomerReferrals';
import ReferralTermsPage from './pages/ReferralTermsPage';
import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Box } from "@mui/material";

import Home from "./pages/Home";
import BuyTicket from "./pages/BuyTicket";
import LiveDraw from "./pages/LiveDraw";
import Winners from "./pages/Winners";
import BottomNav from "./components/BottomNav";
import Register from "./pages/RegistrationEntry";
import Login from "./pages/Login";
import ResponsiveAppBar from "./components/AppBar";
import { Colors } from "./utils/colors";
import ScrollToTop from "./components/ScrollToTop";
import AuthMenu from "./pages/AuthMenu";
import { useDispatch, useSelector} from 'react-redux';
import AccountLayout from "./pages/Account";
import { Navigate } from "react-router-dom";
import Logout from "./pages/Logout";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import MyTickets from "./pages/MyTickets";
import ComingSoon from "./pages/ComingSoon";
import UserDashboard from "./pages/Dashboard";
import WalletPage from "./pages/Wallet";
import FundWallet from "./pages/FundWallet";
import ProfileKYC from "./pages/ProfileKYC";


import ForgotPassword from "./pages/ForgetPassword";
import VerifyOTP from "./pages/VerifyOtp";
import ResetPassword from "./pages/ResetPassword"
import DeleteProfileOTP from "./pages/DeleteProfileOTP";
import VerifyDeleteOTP from "./pages/VerifyDeleteOTP";
import AccountDeletionNotice from "./pages/AccountDeletionNotice";
import HelpSupport from "./pages/HelpSupport";
import LegalFooter from "./components/LegalFooter";
import LegalDocument from "./pages/LegalDocument";
import { API } from "./constant/apiConstant";
import { setBranding } from "./Redux/Reducers/appState";
import PendingPaymentRecoveryGate from "./components/PendingPaymentRecoveryGate";
import UserSessionTimeoutManager from "./components/UserSessionTimeoutManager";
import WebsiteAnalytics from "./components/WebsiteAnalytics";

const  App = ()=> {
  const { pathname } = useLocation();
  const isReferralPage = pathname.replace(/\/+$/, "") === "/refer-and-earn";
  const dispatch = useDispatch();
  const [comingSoon, setComingSoon] = useState(false);
  const [comingSoonNotice, setComingSoonNotice] = useState("");

  useEffect(() => {
    const loadBranding = async () => {
      try {
        const response = await fetch(`${API.BASE_URL}/api/settings`);
        const data = await response.json();

        if (data?.status) {
          dispatch(
            setBranding({
              logoUrl: data.settings?.logo_url || "",
              logoWidth: data.settings?.logo_width || 96,
              logoHeight: data.settings?.logo_height || 96
            })
          );

          setComingSoon(Boolean(Number(data.settings?.is_frontend_coming_soon)));
          setComingSoonNotice(data.settings?.maintenance_notice || "");
        }
      } catch (error) {
        console.log(error);
      }
    };

    loadBranding();
  }, [dispatch]);
  
  function ProtectedRoute({ children }) {
  const isAuth = useSelector((data)=>data.appState.isAuthenticated)
  return isAuth ? children : <Navigate to="/login" />;
}



  return (
    <div>
  
    {comingSoon?<></>:<ResponsiveAppBar />}
      <Box
        sx={{
          pb: 0,
          pt: isReferralPage ? "var(--app-header-height, 96px)" : 10,
          px: { xs: 2, md: 4 },
          maxWidth: 1500,
          mx: "auto",
          backgroundColor: Colors.secondary
        }}
      >
      <ScrollToTop />
      <WebsiteAnalytics />
      <UserSessionTimeoutManager />
      <PendingPaymentRecoveryGate />
        
       {comingSoon ? (
          <ComingSoon notice={comingSoonNotice} />
        ) : (
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/buy" element={<BuyTicket />} />
          <Route path="/draw" element={<LiveDraw />} />
          <Route path="/winners" element={<Winners />} />
          <Route path="/login" element={<Login />} />  
          <Route path="/logout" element={<Logout />} />  
          <Route path="/forgot-password" element={<ForgotPassword />}/>
          <Route path="/verify-reset-otp" element={<VerifyOTP />}/>
         <Route path="/reset-password" element={<ResetPassword />}/>
          <Route path="/refer-and-earn" element={<CustomerReferrals />} />
          <Route path="/refer-and-earn/terms" element={<ReferralTermsPage />} />
          <Route path="/referrals" element={<Navigate to="/refer-and-earn" replace />} />
          <Route path="/influencers" element={<Navigate to="/refer-and-earn" replace />} />
          <Route path="/register" element={<Register />} />   
          <Route path="/influencer/invitation/:token" element={<InfluencerInvitation />} />
          <Route path="/terms-and-conditions" element={<LegalDocument documentType="terms" />} />
          <Route path="/privacy-policy" element={<LegalDocument documentType="privacy" />} />
          <Route path="/cookies-policy" element={<LegalDocument documentType="cookies" />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />

  
          
        <Route
           path="/account"
           element={
          <ProtectedRoute>
           <AccountLayout />
          </ProtectedRoute>
         }
         >
          <Route index path="authmenu" element={<AuthMenu />} /> 
          <Route path="/account/authmenu/account/tickets" element={<MyTickets />} />
           <Route path="/account/authmenu/account/userdashboard" element={<UserDashboard/>} />
           <Route path="/account/authmenu/account/wallets"  element={<WalletPage />} />
           <Route path="/account/authmenu/account/fund-wallet"  element={<FundWallet />} />
           <Route path="/account/authmenu/account/profile-kyc" element={<ProfileKYC />} />
           <Route path="/account/authmenu/account/influencer" element={<InfluencerDashboard />} />
           <Route path="/account/authmenu/account/influencer-history" element={<Navigate to="/account/authmenu/account/influencer" replace />} />
           <Route path="/account/authmenu/account/profile-kyc/deletprofileotp" element={<DeleteProfileOTP />} />
           <Route path="/account/authmenu/account/profile-kyc/verify-delete-otp" element={<VerifyDeleteOTP />} />
           <Route path="/account/authmenu/account/profile-kyc/account-deletion-notice" element={<AccountDeletionNotice />} />
           <Route path="/account/authmenu/account/profile-kyc/support" element={<HelpSupport />} />


    
       </Route>
        </Routes>
       )}
      
      </Box>

      {comingSoon?<></>:<LegalFooter />}
      
      {comingSoon?<></>:<BottomNav />}
      </div>
  );
}


export default App;
